import { ref } from 'vue'
import { useGlobalStore } from '@/stores'
// import { useRoute } from 'vue-router'

export default () => {
  // const $route = useRoute()

  // const perPage = ref(5)
  // const queryBy = ref('title,caption,country,atc,active_substances,mah_name')
  // const searchParameters = ref({
  //   q: $route.query.q,
  //   per_page: perPage.value,
  //   query_by: queryBy.value
  //   // category: $route.query.category?.toString() || '',
  //   // filter_by: props.filter_by,
  //   // filter_by: Object.entries(searchParams.value.filters)
  //   //   .map(([k, v]) => `${k}:=${v}`)
  //   //   .join(' && ')

  // })

  return {
    collection: ref('brands'),
    queryBy: ref('title,caption,country,atc,active_substances,mah_name'),
    perPage: ref(10),
    query: ref(),
    scrollPosition: ref(0),
    totalHits: ref(0),
    hits: ref([]),
    searchParameters: ref({}),
    selectedFilters: ref([]),
    drawerFilters: ref({
      isActive: false,
      width: useGlobalStore().sidebar.initialWidth,
      isOverlay: true
    }),
    filters: ref({
      country: {
        valueKey: 'isoAlpha2',
        labelKey: 'nameEn',
        options: []
      },
      atc: []
    }),
    spcTypes: ref([])
  }
}
